import one1 from './assets/1-1-1.webp';
import one2 from './assets/1-1-2.webp';
import one3 from './assets/1-1-3.webp';
import one4 from './assets/1-1-4.webp';
import one5 from './assets/1-1-5.webp';
import one2_1 from './assets/1-2-1.webp';
import one2_2 from './assets/1-2-2.webp';
import one2_3 from './assets/1-2-3.webp';
import one3_1 from './assets/1-3-1.webp';
import one3_2 from './assets/1-3-2.webp';
import one4_1 from './assets/1-4-1.webp';
import one4_2 from './assets/1-4-2.webp';
import one4_3 from './assets/1-4-3.webp';
import one4_4 from './assets/1-4-4.webp';
import one4_5 from './assets/1-4-5.webp';
import two1_1 from './assets/2-1-1.webp';
import two1_2 from './assets/2-1-2.webp';
import two1_3 from './assets/2-1-3.webp';
import two1_4 from './assets/2-1-4.webp';
import two2_1 from './assets/2-2-1.webp';
import two2_2 from './assets/2-2-2.webp';
import two3_1 from './assets/2-3-1.webp';
import two3_2 from './assets/2-3-2.webp';
import two3_3 from './assets/2-3-3.webp';
import two4_1 from './assets/2-4-1.webp';
import two4_2 from './assets/2-4-2.webp';
import three1_1 from './assets/3-1-1.webp';
import three1_2 from './assets/3-1-2.webp';
import three1_3 from './assets/3-1-3.webp';
import three1_4 from './assets/3-1-4.webp';
import three2_1 from './assets/3-2-1.webp';
import three6_1 from './assets/3-6-1.webp';
import img1 from './assets/1.webp';
import img2 from './assets/2.webp';
import img3 from './assets/3.webp';
import img4 from './assets/4.webp';
import two2_3 from './assets/3-6-2.webp';
import two3_6_3 from './assets/3-6-3.webp';
import two3_6_4 from './assets/3-6-4.webp';

const card = (id, title, image, tag = 'тег', href = 'https://prichal-dom.ru/search/params') => ({
  id,
  tag,
  image,
  title,
  href,
});

export const layoutsContent = {
  title: 'выбирайте планировку<br> подходящую <span>под ваш<br> образ жизни</span>',
  text: 'можно выбрать квартиру с увеличенной спальней,<br> кухней-гостиной или гардеробной зоной',
  description:
    'Обычно застройщику проще делать одинаковые<br> планировки. <span>Мы спроектировали несколько вариантов<br> под разные сценарии жизни. Это сложнее, но честнее<br> по отношению к покупателю</span>',
  ctaLabel: 'выбрать планировку →',
  tabs: [
    {
      id: 'studio',
      label: 'студии',
      pages: [
        {
          cards: [
            card('1-4-5', 'Базовое планировочное<br> решение', one4_5, '28.86 м²'),
            card('1-4-1', 'C ТВ-зоной', one4_1, '28 м² / 12.8 м²'),
            card('1-4-2', 'C зонированной перегородками<br> кухней', one4_2, '28.73 м² / 12.80 м²'),
            card('1-4-3', 'C большим столом<br> и рабочим местом', one4_3, '28.55 м² / 12.80 м²'),
            card('1-4-4', 'C барной стойкой<br> и необычной кухней', one4_4, '28.86 м² / 16.19 м²'),
          ],
        },
      ],
    },
    {
      id: '1',
      label: '1-комнатные',
      pages: [
        {
          typeTitle: 'Квартира №1',
          cards: [
            card('1-1-5', 'Базовое планировочное<br> решение ', one5, '39.54 м²'),
            card(
              '1-1-1',
              ' С просторной спальней-<br>кабинетом и мини-гостиной',
              one1,
              '38.28 м² / 12.96 м²'
            ),
            card(
              '1-1-2',
              'C кухней-гостиной<br> и вместительной гардеробной',
              one2,
              '38.30 м² / 13.17 м²'
            ),
            card(
              '1-1-3',
              ' C большим коридором<br> и кухней-гостиной',
              one3,
              '38.17 м² / 11.38 м²'
            ),
            card('1-1-4', 'C увеличенными спальней<br> и гардеробной', one4, '38.26 м² / 13.46 м²'),
          ],
        },
        {
          typeTitle: 'Квартира №2',
          cards: [
            card('1-2-3', 'Базовое планировочное<br> решение ', one2_3, '39.08 м²'),
            card(
              '1-2-1',
              'C компактной прихожей<br> и гардеробной в гостиной',
              one2_1,
              '37.11 м² / 13.31 м²'
            ),
            card('1-2-2', 'C нишей для двуспальной<br> кровати', one2_2, '37.19 м² / 16.81 м²'),
          ],
        },
        {
          typeTitle: 'Квартира №3',
          cards: [
            card('1-3-2', 'Базовое планировочное<br> решение', one3_2, '38.34 м²'),
            card(
              '1-3-1',
              'C кухней-гостиной<br> и отдельной спальней',
              one3_1,
              '38.48 м² / 14.20 м²'
            ),
          ],
        },
      ],
    },
    {
      id: '2',
      label: '2х-комнатные',
      pages: [
        {
          typeTitle: 'Квартира №1',
          cards: [
            card('2-1-4', 'Базовое планировочное<br> решение', two1_4, '51.94 м²'),
            card('2-1-1', 'C гардеробной<br> и большой гостиной', two1_1, '50.71 м² / 27.04 м²'),
            card(
              '2-1-2',
              'C двумя спальнями<br> и небольшой зоной гостиной',
              two1_2,
              '50.64 м² / 20.61 м²'
            ),
            card(
              '2-1-3',
              'C кухней-гостиной<br> и большой мастер-спальней',
              two1_3,
              '50.84 м² / 23.77 м²'
            ),
          ],
        },
        {
          typeTitle: 'Квартира №2',
          cards: [
            card('2-2-2', 'Базовое планировочное<br> решение', two2_2, '56.69 м²'),
            card('2-2-1', 'С нишами для шкафов<br> в коридоре ', two2_1, '56.15 м² / 24.78 м²'),
          ],
        },
        {
          typeTitle: 'Квартира №3',
          cards: [
            card('3-6-1', 'Базовое планировочное<br> решение', three6_1, '56.69 м2'),
            card(
              '2-3-1',
              'С гардеробной, кухней-гостиной<br> и 2 спальнями',
              two3_1,
              '54.81 м² / 22.28 м²'
            ),
            card(
              '2-3-2',
              'C необычной кухней и увеличенным<br> количеством мест хранения',
              two3_2,
              '54.58 м² / 24.53 м²'
            ),
            card(
              '2-3-3',
              'C мастер-спальней, необычной<br> кухней и увеличенным<br> количеством мест хранения',
              two3_3,
              '54.58 м² / 25.90 m²'
            ),
          ],
        },
        {
          typeTitle: 'Квартира №4',
          cards: [
            card('3-6-1', 'Базовое планировочное<br> решение', two2_3, '57.35 м2'),
            card(
              '2-4-1',
              'C гардеробной в прихожей, мастер-<br>спальней и кухней-гостиной',
              two4_1,
              '28 м² / 10 м²'
            ),
            card(
              '2-4-2',
              'C увеличенной гардеробной при<br> входе и большой гостиной',
              two4_2,
              '28 м² / 10 м²'
            ),
          ],
        },
      ],
    },
    {
      id: '3',
      label: '3х-комнатные',
      pages: [
        {
          typeTitle: 'Квартира №1',
          cards: [
            card('3-2-2', 'Базовое планировочное<br> решение', two3_6_3, '70.61 м²'),
            card('3-1-1', 'C двумя гардеробными', three1_1, '28 м² / 10 м²'),
            card(
              '3-1-2',
              'C мастер-спальней и <br>зонированной кухней-гостиной',
              three1_2,
              '28 м² / 10 м²'
            ),
            card(
              '3-1-3',
              'C мастер-спальней и <br>объединенной кухней-гостиной',
              three1_3,
              '28 м² / 10 м²'
            ),
            card(
              '3-1-4',
              'C мастер-спальней и большим<br> открытым пространством кухни-гостиной',
              three1_4,
              '28 м² / 10 м²'
            ),
          ],
        },
        {
          typeTitle: 'Квартира №2',
          cards: [
            card('3-2-2', 'Базовое планировочное<br> решение', two3_6_4, '75.61 м²'),
            card('3-2-1', 'C гардеробной и <br>мастер-спальней', three2_1, '73.23 м² / 38.81 м²'),
          ],
        },
      ],
    },
  ],
  list: [
    {
      image: img1,
      itemTitle: 'формат <br> «Мастер-спальня»',
      itemText: 'cпальня родителей имеет<br> <span>собственный санузел <br> и гардеробную</span>',
    },
    {
      image: img2,
      itemTitle: 'видовые лоты',
      itemText:
        'окна выходят прямо <br> на акваторию Камы <span>или<br> массив соснового бора</span>',
    },
    {
      image: img3,
      itemTitle: 'квартиры с 2 санузлами',
      itemText:
        'удобное решение для семей с<br> детьми. Никаких утренних<br> очередей перед школой <span>и<br> работой, а гостевой санузел<br> сохранит приватность вашей<br> личной ванной</span>',
    },
    {
      image: img4,
      itemTitle: 'лоты с гардеробными',
      itemText:
        'освободите жилое пространство<br> от массивных шкафов-купе.<br> <span>отдельное помещение для<br> хранения вещей поможет<br> сохранить визуальную чистоту <br>и порядок в комнатах</span>',
    },
  ],
};
